<template>
  <div id="pageMaturities">
    <v-container grid-list-xl fluid>
      <v-btn
        class="btn-add"
          color="white"
          small
          absolute
          fab
          :to="{ name: 'AuxMaturityNew'}"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <v-container fill-height fluid>
          <v-layout fill-height>
            <v-flex xs2>
              Id
            </v-flex>
            <v-flex xs3>
              Nome
            </v-flex>
          </v-layout>
        </v-container>
      <div class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
          v-if="paginatationDisabled"
        ></v-progress-circular>
      </div>
      <v-card class="card-maturityAux" v-for="(maturityAux, index) in maturityAuxs.data" :key="`maturityAux${maturityAux.id}`">
        <v-container>
          <v-layout>
            <v-flex xs2>
              <p style="margin: 6px 0px;">{{maturityAux.id}}</p>
            </v-flex>
            <v-flex xs3>
              <p style="margin: 6px 0px;">{{maturityAux.name}}</p>              
            </v-flex>
            <v-flex xs7 class="text-xs-right">
              <v-btn fab small :to="{ name: 'AuxMaturityEdit', params: { id: maturityAux.id }}" color="primary"><v-icon>edit</v-icon></v-btn>
              <v-btn fab small color="error" @click.stop="clickDeleteMaturity(index)"><v-icon>delete</v-icon></v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
      <app-pagination v-if="maturityAuxs && maturityAuxs.pagination"
        :pagination="maturityAuxs.pagination"
        :disabled="paginatationDisabled"
        v-on:change-page="changePage"
        ></app-pagination>
      <app-confirm-modal 
        :message="deleteMessage" 
        :dialog="dialog" 
        :modalType="modalType"
        v-on:choose="deleteMaturity"></app-confirm-modal>
      
      <v-snackbar
        :timeout="3000"
        bottom
        right
        :color="snackbar.color"
        v-model="snackbar.show"
      >
        {{ snackbar.text }}
        <v-btn dark text @click.native="snackbar.show = false" icon> 
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>    
    </v-container>
  </div>
</template>

<script>
import appApi from '../../../plugins/api';
import AppPagination from '../../../components/Pagination';
import ConfirmModal from '../../../components/ConfirmModal';

export default {
  components: {
    'app-pagination' : AppPagination,
    'app-confirm-modal' : ConfirmModal
  },
  data: function() {
    return {
      maturityAuxs : {},
      paginatationDisabled : false,
      dialog : false,
      deleteMaturityId : null,
      deleteMessage : '',
      modalType : null,
      snackbar : {}
    }
  },

  computed: {
  },

  mounted: function() {
    this.getAuxMaturity();
  },

  methods: {
    getAuxMaturity: function(page) {
      this.paginatationDisabled = true;
      this.maturityAuxs.data = [];
      appApi.getAuxMaturities({page : (page ? page : 1)}).then(result => {
        this.maturityAuxs = result.data;
        this.paginatationDisabled = false;
      }).catch(error => {
        console.log('error', error);
      });
    },
    changePage(page) {
      this.getAuxMaturity(page);
    },
    clickDeleteMaturity(index) {
      this.dialog = true;
      this.deleteMaturityId = index;
      this.modalType = 'error';
      this.deleteMessage = 'Tem certeza que deseja deletar <strong>'+this.maturityAuxs.data[index].name+'</strong>?';
    },
    deleteMaturity(confirm) {
      this.dialog = false;
      if (confirm) {
        appApi.deleteAuxMaturity(this.maturityAuxs.data[this.deleteMaturityId].id).then(()=>{
          this.changePage(1);
          this.snackbar = {
            show: true,
            color: "green",
            text: "Apagado com sucesso."
          };
        }).catch(()=>{
          this.changePage(1);
          this.snackbar = {
            show: true,
            color: "error",
            text: "Não foi possível apagar."
          };
        });
      }
    }
  }

};
</script>
<style scoped lang="css">
  #pageMaturities {
    position: relative;
  }
  #pageMaturities .btn-add {
    position: fixed;
    top: 90px;
    left: calc(100% - 60px);
  }
  #pageMaturities .card-maturityAux {
    margin-bottom: 10px;
  }
</style>

